import React from "react";

const COLORS = {
  green: "#6B9080",
  orange: "#F6AA1C",
  red: "#E63946",
  gray: "#D3D3D3",
};
const LABELS = {
  green: "Még van hely",
  orange: "Hamarosan betelik",
  red: "Már csak néhány hely",
  gray: "Betelt",
};

export const SeatIndicator = ({ info, showLabel = true, showCount = true }) => {
  if (!info) return null;
  const color = COLORS[info.indicator] || COLORS.gray;
  return (
    <div className="w-full" data-testid="seat-indicator">
      {showLabel && (
        <div className="flex items-center justify-between text-sm font-medium text-ink/70">
          <span className="flex items-center gap-1.5" data-testid="seat-status">
            <span className="inline-block h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
            {LABELS[info.indicator]}
          </span>
          {showCount && <span data-testid="seat-count">{info.available_seats} / {info.total_seats} szabad</span>}
        </div>
      )}
    </div>
  );
};
